<template>
  <div>
    <QueryFrame
      :count="count"
      :current="page"
      @handlePage="handlePage"
      @handlePageSize="handlePageSize">
      <div slot="queryParams">
        <div class="queryContainer">
          <div class="queryItem">
            <label>医保病种名:</label>
            <lk-input :maxlength="100" placeholder="请输入" class="item" clearable v-model.trim="query.AKA121"></lk-input>
          </div>
          <div class="queryItem">
            <label>诊断说明:</label>
            <lk-select class="item" v-model.trim="query.saleDiseaseId">
              <lk-option
                v-for="(item) in diseaseList"
                :key="item.id"
                :value="item.id">{{item.diseaseName}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <lk-button class="mr" type="primary" @click="handleSearch">查询</lk-button>
            <lk-button @click="handleReset">重置</lk-button>
          </div>
        </div>
      </div>
      <div slot="table">
        <lk-table border :columns="columns" :data="tableData"></lk-table>
      </div>
    </QueryFrame>
    <!-- 编辑弹出层 开始 -->
    <lk-modal
      v-model="modal.visiable"
      :mask-closable="false"
      title="编辑"
      @on-cancel="cancelModal">
      <lk-form
        label-position="right"
        :label-width="150"
        :rules="rules"
        :model="formModel"
        ref="form">
        <div class="modalContainer">
          <lk-row :gutter="16">
            <lk-col :span="20">
              <lk-form-item label="病种名称:">
                <!--<lk-input :maxlength="100" placeholder="请输入" class="item" clearable v-model.trim="formModel.aka121"></lk-input>-->
                <span>{{formModel.aka121}}</span>
              </lk-form-item>
            </lk-col>
          </lk-row>
          <lk-row :gutter="16">
            <lk-col :span="20">
              <lk-form-item label="诊断说明:" prop="saleDiseaseId">
                <lk-select
                  v-model="formModel.saleDiseaseId"
                  label-in-value
                  @on-change="handleSaleDiseaseChange">
                  <lk-option
                    v-for="(item) in diseaseList"
                    :key="item.id"
                    :value="item.id">{{item.diseaseName}}</lk-option>
                </lk-select>
              </lk-form-item>
            </lk-col>
          </lk-row>
        </div>
      </lk-form>
      <div slot="footer">
        <div>
          <lk-button @click="cancelModal">取消</lk-button>
          <lk-button type="primary" @click="handleEdit" :loading="modal.loading">提交</lk-button>
        </div>
      </div>
    </lk-modal>
    <!-- 编辑弹出层 结束 -->
  </div>
</template>
<script>
import QueryFrame from '../../../components/frame/QueryFrame.vue';
import utils from '../../../libs/utils';
import insurance from '../../../services/insurance';
import sale from '../../../services/sale';
import mapState from '../../../mixins/mapState'; // 鉴权
import queryMixins from '../../../mixins/queryMixins';

export default {
  name: 'InsuranceToDisease',
  mixins: [mapState, queryMixins],
  components: {
    QueryFrame,
  },
  computed: {
    hasEdit() {
      return this.handlePermission('insuranceToDiseaseUpdate ');
    },
  },
  data() {
    return {
      query: {
        AKA121: null,
        saleDiseaseId: null,
      },
      modal: {
        visiable: false,
        loading: false,
      },
      formModel: {
      },
      rules: {
        // aka121: [{ required: true, message: '请输入病种名称' }],
        saleDiseaseId: [{ required: true, message: '请选择诊断说明' }],
      },
      diseaseList: [],
      columns: [
        {
          title: '序号',
          type: 'index',
          minWidth: 80,
          indexMethod: row => (row._index + this.size * (this.page - 1)) + 1,
        },
        {
          title: '所属经办结构',
          key: 'aab034',
          minWidth: 116,
        },
        {
          title: '病种名称',
          key: 'aka121',
          minWidth: 116,
        },
        {
          title: '病种代码',
          key: 'aka120',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '诊断说明',
          key: 'saleDiseaseName',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '诊断说明ID',
          key: 'saleDiseaseId',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '助记码',
          key: 'aka066',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '病种分类',
          key: 'aka122',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '操作',
          key: 'action',
          minWidth: 116,
          render: (h, { row }) => h('lk-button', {
            props: {
              type: 'text',
              size: 'small',
            },
            on: {
              click: () => {
                this.handleShowEdit(row, 1);
              },
            },
          }, '编辑'),
        },
      ],
      tableData: [],
    };
  },
  methods: {
    handleReset() {
      this.query = {};
    },
    getData() {
      this.params.page = this.page;
      this.params.size = this.size;
      insurance.insuranceToDiseaseList(this.params).then((res) => {
        if (res.data.status === 200) {
          const { count, list } = res.data.data;
          this.count = count;
          this.tableData = list;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    handleShowEdit(row) {
      this.formModel = utils.deepClone(row);
      this.modal.visiable = true;
    },
    handleEdit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$store.commit('setDisableLoading', true);
          const params = utils.deepClone(this.formModel);
          delete params._index;
          delete params._rowKey;
          this.modal.loading = true;
          insurance.insuranceToDiseaseEdit(this.keyToUpperCase(params, ['saleDiseaseName', 'saleDiseaseId']))
            .then((res) => {
              if (res.data.status === 200) {
                this.$Message.success('编辑成功');
                this.modal.visiable = false;
                this.getData(true);
              } else {
                this.$Message.error(res.data.error);
              }
              this.modal.loading = false;
            })
            .catch((err) => {
              this.modal.loading = false;
              utils.handleError(err);
            });
        } else {
          this.$Message.error(' 请按照要求填写');
        }
      });
    },
    getDiseaseList() {
      return new Promise((resolve) => {
        sale.getDiseaseInfo().then((res) => {
          if (res.data.status === 200) {
            this.diseaseList = res.data.data;
            resolve();
          } else {
            this.$Message.error(res.data.error);
          }
        }).catch((err) => {
          utils.handleError(err);
        });
      });
    },
    handleSaleDiseaseChange(item) {
      this.formModel.saleDiseaseName = item.label;
    },
    cancelModal() {
      this.$refs.form.resetFields();
      this.modal.visiable = false;
    },
    keyToUpperCase(obj, ignoreList = []) {
      for (const key in obj) {
        if (!ignoreList.includes(key)) {
          obj[`${key.toUpperCase()}`] = obj[key];
          delete (obj[key]);
        }
      }
      return obj;
    },
  },
  created() {
    this.handleSearch(true);
    this.getDiseaseList();

    // 没有编辑权限，移除操作列
    if (!this.hasEdit) {
      this.columns.pop();
    }
  },
};
</script>
<style lang="less" scoped>
</style>
